export enum BaseWorkerLifeCycleEnum {
	INIT,
	TRIGGERED,
	COMPLETED
}
